// extracted by mini-css-extract-plugin
export default {"surfaceType":"ElevationChart--surfaceType--b2a+t"};